// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"vo-z","imageAndVideoCount":"wo-z","imageAndVideoContainer":"xo-z","viewAllReviews":"yo-z"};